'use client';

import { useEffect, useState } from 'react';

import classnames from 'classnames';

import { DropdownIcon } from '../dropdown-icon';
import { SlideDown } from '../slide-down';
import { Text } from '../text';
import type { CollapsibleSectionProps } from './CollapsibleSection.types';

import styles from './CollapsibleSection.module.scss';

function CollapsibleSection({
  style,
  className,
  title,
  description,
  defaultOpen = false,
  children,
  testId = 'ui-collapsible-section',
  onOpen,
  onClose,
}: CollapsibleSectionProps) {
  const [closed, setClosed] = useState(!defaultOpen);

  const handleToggleSubMenu = () => {
    setClosed(!closed);
  };

  useEffect(() => {
    if (closed) {
      if (onClose) {
        onClose();
      }
    } else {
      if (onOpen) {
        onOpen();
      }
    }
  }, [closed, onClose, onOpen]);

  return (
    <div
      style={style}
      className={classnames(styles['collapsible-section'], className)}
      data-testid={testId}
    >
      <button
        type="button"
        className={styles['head']}
        onClick={handleToggleSubMenu}
        aria-expanded={!closed}
        data-testid={`${testId}_button`}
      >
        <span className={styles['header']} data-testid={`${testId}_title`}>
          {title}
        </span>
        <DropdownIcon size="sm" closed={closed} />
      </button>
      {description && (
        <Text
          data-testid={`${testId}_description`}
          variety="annotation"
          className={classnames(styles['description'])}
        >
          {description}
        </Text>
      )}
      <SlideDown testId={`${testId}_payload`}>
        {!closed ? <>{children}</> : null}
      </SlideDown>
    </div>
  );
}

export { CollapsibleSection };
